import { render, staticRenderFns } from "./EventBooking.vue?vue&type=template&id=2f87aa72&scoped=true&"
import script from "./EventBooking.vue?vue&type=script&lang=js&"
export * from "./EventBooking.vue?vue&type=script&lang=js&"
import style0 from "./EventBooking.vue?vue&type=style&index=0&id=2f87aa72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87aa72",
  null
  
)

export default component.exports